import { Basics, isMobile, isTouch } from '../core/Basics';
import { GetBy } from '../core/Element';
import EventDispatcher from '../core/EventDispatcher';
import { gsap, Power3 } from 'gsap';
import { Scroll } from '../scroll/Scroll';

export default class _Header {
  static container = GetBy.id("Header");
  static logo = GetBy.id("LogoHeader");
  static logoLink = GetBy.class("logo", this.container)[0];

  static ON_SHOW = "HEADERSHOW";
  static ON_HIDE = "HEADERHIDE";
  static isShow = true;
  static isShowing = true;
  static isFixed = false;
  static showOnBack = true;
  static hasBG = false;

  static _y = 0;
  static oldY = 0;
  static height;
  static yOffset = 0;

  static _idTimerBG = 0;

  static options = {
    show: {
      duration: .6,
      delay: 0,
      ease: Power3.easeOut
    },
    hide: {
      duration: .3,
      delay: 0,
      ease: Power3.easeIn
    }
  }

  static get y() { return this._y; }
  static set y(__y) {
    this._y = Math.max(-this.height, __y);
    document.body.style.setProperty('--y-header', `${this.y}px`);
  }

  static init() {
    this.height = this.container.offsetHeight + this.yOffset;
    gsap.set(this.logo, { opacity: 0 });

    this.directHide();

    this.logoLink.addEventListener(Basics.mouseOver, () => {
      this.showLogo();
    });
    this.logoLink.addEventListener(Basics.mouseOut, () => {
      this.hideLogo();
    });
  }

  static directShow() {
    this.isShow = true;
    this.container.style.opacity = 1;
  }

  static show() {
    if (!this.isShow) {
      this.isShow = true;
      this.show__effect();
    }
  }

  static show__effect() {
    EventDispatcher.dispatchEvent(_Header.ON_SHOW);

    // gsap.to(this, {
    //   y: 0,
    //   duration: this.options.show.duration,
    //   delay: this.options.show.delay,
    //   ease: this.options.show.duration.ease,
    //   onComplete: () => {
    //     this.isShowing = false;
    //   }
    // });

    this.isShowing = false;
    this.container.style.opacity = 1;
  }

  static directHide() {
    this.isShow = false;
    // this.y = -this.height;

    this.container.style.opacity = 0;
  }

  static hide() {
    if (this.isShow) {
      this.isShow = false;
      this.hide__effect();
    }
  }

  static hide__effect() {
    EventDispatcher.dispatchEvent(_Header.ON_HIDE);
    // gsap.to(this,
    // {
    // y: -this.height,
    // duration: this.options.hide.duration,
    // delay: this.options.hide.delay,
    // ease: this.options.hide.duration.ease,
    // onComplete: () => {
    // this.isShowing = false;
    // }
    // });
    this.container.style.opacity = 0;
    this.isShowing = false;
  }

  static showBG(__class = "--with-bg", __delay = 0) {
    this.hasBG = true;
    if (this._idTimerBG) clearTimeout(this._idTimerBG);

    this._idTimerBG = setTimeout(() => { this.container.classList.add(__class) }, __delay)
  }

  static hideBG(__class = "--with-bg", __delay = 0) {
    this.hasBG = false;
    if (this._idTimerBG) clearTimeout(this._idTimerBG);

    this._idTimerBG = setTimeout(() => { this.container.classList.remove(__class) }, __delay)
  }

  static directShowLogo() {
    gsap.set(this.logo, { opacity: 0 });
    gsap.set(this.logo, { opacity: 1, delay: .1 });
    gsap.set(this.logo, { opacity: 0, delay: .2 });
    gsap.set(this.logo, { opacity: 1, delay: .3 });
  }

  static showLogo() {
    if (isMobile) return;

    gsap.killTweensOf(this.logo);
    gsap.set(this.logo, { opacity: 0 });
    gsap.set(this.logo, { opacity: 1, delay: .1 });
    gsap.set(this.logo, { opacity: 0, delay: .2 });
    gsap.set(this.logo, { opacity: 1, delay: .3 });
  }

  static hideLogo() {
    gsap.killTweensOf(this.logo);

    // console.log('HIDE', isMobile, force);

    // if (isMobile || !force) {
    //   console.log('OR MOBILE OR NOT FORCE');
    //   gsap.set(this.logo, { opacity: 0 });
    // } else {
    gsap.set(this.logo, { opacity: 1 });
    gsap.set(this.logo, { opacity: 0, delay: .1 });
    gsap.set(this.logo, { opacity: 1, delay: .2 });
    gsap.set(this.logo, { opacity: 0, delay: .3 });
    // }
  }

  static resize() {
    this.height = this.container.offsetHeight + this.yOffset;
  }

  static loop() {
    if (!Scroll.isEnabled()) return;

    if (!this.isFixed) {
      const DELTA = Scroll.y - this.oldY;
      const POS_Y = Math.min(0, Math.max(-this.height, this.y + DELTA));

      if (Scroll.direction === -1 && !this.isShow) {
        this.show();
      } else if (Scroll.direction === 1) {
        this.isShow = false;
        if (this.isShowing) {
          gsap.killTweensOf(this);
        }

        if (Scroll.y <= 0) this.y = POS_Y;

        if (POS_Y === -this.height && !this.hasBG) {
          this.showBG();
        }
      }

      if (Scroll.y >= -10 && this.hasBG) {
        this.hideBG();
      }

      this.oldY = Scroll.y;
    } else if (this.isFixed) {
      if (Scroll.y < -this.height && !this.hasBG) {
        this.showBG();
      } else if (Scroll.y > -this.height && this.hasBG) {
        this.hideBG();
      }
    }
  }
}
